import { createContext, useContext, useState } from "react";

export const UserProfileContext = createContext({
  timeZoneList: [],
  setTimeZoneList: () => {},
  selectedImage: null,
  setSelectedImage: () => {},
  timeZone: null,
  setTimeZone: () => {},
  displayName: null,
  setDisplayName: () => {},
  userEmail: null,
  setUserEmail: () => {},
  jobTitle: null,
  setJobTitle: () => {},
  taskCode: null,
  setTaskCode: () => {},
  reminderTime: null,
  setReminderTime: () => {},
  boardName: null,
  setBoardName: () => {},
  profileControlsDataList: [],
  setProfileControlDataList: () => {},
  profileControls: [],
  setProfileControls: () => {},
  googleSSOValues: [],
  setGoogleSSOValues: () => {},
  userIdValues: [],
  setUserIdValues: () => {},
  selectedImageFolder: "",
  setSelectedImageFolder: () => {},
  profileData: {},
  setProfileData: () => {},
  initialTimeZone: null,
  setInitialTimeZone: () => {},
  isEnableSaveButton: false,
  setIsEnableSaveButton: () => {},
  initialValues: {
    displayName: null,
    jobTitle: null,
    taskCode: null,
    reminderTime: null,
    timeZone: null,
    selectedImage: null,
    profileData: {},
  },
  setInitialValues: () => {},
});

/**
 * Wrapper component for user profile context provider
 * @autor Bhavana
 */
export const UserProfileContextProvider = ({ children }) => {
  const [timeZoneList, setTimeZoneList] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [timeZone, setTimeZone] = useState(null);
  const [initialTimeZone, setInitialTimeZone] = useState(null);
  const [displayName, setDisplayName] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [jobTitle, setJobTitle] = useState(null);
  const [taskCode, setTaskCode] = useState(null);
  const [reminderTime, setReminderTime] = useState(null);
  const [boardName, setBoardName] = useState(null);
  const [googleSSOValues, setGoogleSSOValues] = useState([]);
  const [userIdValues, setUserIdValues] = useState([]);
  const [selectedImageFolder, setSelectedImageFolder] = useState("");
  const [profileData, setProfileData] = useState({});
  const [jobRole, setJobRole] = useState("");
  const [department, setDepartment] = useState("");
  const [officeLocation, setOfficeLocation] = useState("");
  const [profileControlsDataList, setProfileControlDataList] = useState([]);
  const [profileControls, setProfileControls] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEnableSaveButton, setIsEnableSaveButton] = useState(false);
  const [updatedVariables, setUpdatedVariables] = useState([]);
  const [sortingOrder, setSortingOrder] = useState("");
  const [initialValues, setInitialValues] = useState({
    displayName: null,
    jobTitle: null,
    taskCode: null,
    reminderTime: null,
    timeZone: null,
    selectedImage: null,
    profileData: {},
  });

  const value = {
    timeZoneList,
    setTimeZoneList,
    selectedImage,
    setSelectedImage,
    timeZone,
    setTimeZone,
    displayName,
    setDisplayName,
    userEmail,
    setUserEmail,
    jobTitle,
    setJobTitle,
    taskCode,
    setTaskCode,
    reminderTime,
    setReminderTime,
    boardName,
    setBoardName,
    googleSSOValues,
    setGoogleSSOValues,
    userIdValues,
    setUserIdValues,
    selectedImageFolder,
    setSelectedImageFolder,
    profileData,
    setProfileData,
    initialTimeZone,
    setInitialTimeZone,
    jobRole,
    setJobRole,
    department,
    setDepartment,
    officeLocation,
    setOfficeLocation,
    profileControlsDataList,
    setProfileControlDataList,
    profileControls,
    setProfileControls,
    loading,
    setLoading,
    isEnableSaveButton,
    setIsEnableSaveButton,
    initialValues,
    setInitialValues,
    updatedVariables,
    setUpdatedVariables,
    sortingOrder,
    setSortingOrder,
  };

  return <UserProfileContext.Provider value={value}>{children}</UserProfileContext.Provider>;
};

// Custom hook to use the UserProfileContext
export const useProfileContext = () => {
  return useContext(UserProfileContext);
};
